import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCountdown } from "../helper/Countdown";
import toast from "react-hot-toast";
import productData from "../data/products.json";

const DealsOne = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  // Load JSON from import instead of fetch
  useEffect(() => {
    const filtered = productData.filter(
      (item) =>
        item.category &&
        (item.category.toLowerCase().includes("laser-printer") ||
          item.category.toLowerCase().includes("inkjet-printer"))
    );

    setProducts(filtered);
  }, []);

  // Countdown (kept)
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  useEffect(() => {
    const interval = setInterval(() => setTimeLeft(getCountdown()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Add to cart logic
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login-now");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity++;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));

    // 🔥 Trigger header update instantly (fixes no-refresh issue)
    window.dispatchEvent(new Event("cart-updated"));

    toast.success(`${product.name} added to cart!`);
  };

  const formatCategory = (str) =>
    str.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  // Generate extra UI metadata
  const productsWithRandomData = useMemo(() => {
    return products.map((item) => {
      const rating = (Math.random() * 1 + 4).toFixed(1);
      const reviews = Math.floor(Math.random() * 400) + 100;
      const randomTags = ["Wi-Fi", "Best Seller", "Smart Print", "Eco Mode"]
        .sort(() => 0.5 - Math.random())
        .slice(0, 2);

      return {
        ...item,
        rating,
        reviews,
        features: randomTags,
        formattedCategory: formatCategory(item.category || "Printer"),
      };
    });
  }, [products]);

  return (
    <section className="deals pt-30 pb-30">
      <div className="container container-lg">
        <div className="title-area text-center">
          <span className="sub-title">Shop by Category</span>
          <h2 className="sec-title mt-3">Inkjet Printers For You</h2>
        </div>

        <div className="product-grid">
          {productsWithRandomData.map((item) => {
            const img =
              item.image || item.imageUrl || "/assets/images/placeholder.png";
            const finalPrice = item.salePrice || item.price;

            return (
              <div className="card" key={item.id}>
                <Link to={`/product-details/${item.id}`} className="img-box">
                  <img src={img} alt={item.name} />
                  {item.salePrice && <span className="tag sale">SALE</span>}
                </Link>

                <div className="card-body">
                  <p className="category">{item.formattedCategory}</p>

                  <Link to={`/product-details/${item.id}`} className="title">
                    {item.name}
                  </Link>

                  <div className="tags">
                    {item.features.map((tag, i) => (
                      <span key={i} className="tiny-tag">
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="pricing">
                    <span className="price">${finalPrice}</span>
                    {item.salePrice && (
                      <span className="old">${item.price}</span>
                    )}
                  </div>

                  <div className="rating">
                    ⭐ {item.rating} ({item.reviews} Reviews)
                  </div>

                  <button className="btn" onClick={() => handleAddToCart(item)}>
                    Add to Cart 🛒
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* === INLINE STYLING === */}
      <style>{`
        .heading {
          text-align: center;
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 30px;
        }

        .product-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 30px;
        }

        .card {
          background: #f8faff;
          border-radius: 18px;
          overflow: hidden;
          border: 1px solid #eee;
          transition: .3s;
          box-shadow: 0 6px 16px rgba(0,0,0,0.06);
        }

        .card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 35px rgba(0,0,0,0.15);
        }

        .img-box {
          background: #fff;
          display: flex;
          justify-content: center;
          padding: 24px;
          position: relative;
        }

        .img-box img {
          width: 75%;
          transition: .3s;
        }

        .card:hover img {
          transform: scale(1.05);
        }

        .tag.sale {
          position: absolute;
          top: 12px;
          right: 12px;
          background: #ff3b3b;
          padding: 6px 12px;
          font-size: 12px;
          border-radius: 6px;
          color: white;
        }

        .card-body {
          padding: 20px;
        }

        .category {
          font-size: 13px;
          color: #777;
          font-weight: 600;
        }

        .title {
          font-size: 17px;
          font-weight: 700;
          color: #222;
          text-decoration: none;
          margin: 6px 0 10px;
          display: block;
        }

        .tags {
          display: flex;
          gap: 6px;
          margin-bottom: 10px;
        }

        .tiny-tag {
          background: #eef6ff;
          padding: 5px 10px;
          border-radius: 10px;
          font-size: 11px;
          color: #0072f5;
          font-weight: bold;
        }

        .pricing {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .price {
          font-weight: 800;
          color: #0b5ed7;
          font-size: 20px;
        }

        .old {
          text-decoration: line-through;
          font-size: 13px;
          color: #888;
        }

        .rating {
          font-size: 14px;
          margin: 10px 0;
          color: #ff9f00;
          font-weight: bold;
        }

        .btn {
          margin-top: 12px;
          width: 100%;
          background: #0b5ed7;
          color: #fff;
          border: none;
          padding: 12px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 700;
          transition: .3s;
        }

        .btn:hover {
          background: #084eb5;
          color:white;
        }
      `}</style>
    </section>
  );
};

export default DealsOne;
